function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// @ts-strict-ignore
/** @jsx jsx */
/** @jsxFrag null */
import { jsx, ParamComponent } from 'panel';
import { Section, SectionItem } from 'common/components/items-menu/types';
import { SvgIconEl } from 'common/components/svg-icon';
import { DEFAULT_SEARCH_QUERY_STRING, getBrowseUrl, PROMPT_ALLOW_STORAGE_STRING, searchUtils } from 'common/report/util/search';
import { TypeaheadTrackedEvent } from 'common/report/util/search/tracking';
import { RecentSearchItemType } from 'common/report/util/search/types';
import { KEY_VALUES } from 'common/util/dom';
import { defineAndMakeJsxFactory } from 'common/util/jsx';
import { Visibility, VisibilityChangeEvent } from 'common/components/base/stackable';
import { DropMenuEl } from 'common/components/drop-menu';
import { InputEl } from 'common/components/input';
import { InputTheme } from 'common/components/input/types';
import { ItemsMenuEl } from 'common/components/items-menu';
import { useEventListener } from 'common/util/component-helpers';
import { IronContextRegistry } from 'common/report/context-registry';
import { panel2react } from 'common/util/react';
import css from './index.inline.styl';
const RECENT_TERM_TYPE = "mp-search-input-recent-term";
export enum ResultDisplayMode {
  DropMenu = "drop-menu",
  List = "list",
}
type SearchInputState = {
  allowRecentItems?: boolean;
  isMenuOpen: boolean;
  searchInputEl?: HTMLElement;
};
export type SearchInputParams<ItemType = any> = {
  actionText?: string;
  onEnterPressed?: () => void;
  onItemClick?: (item: SectionItem<ItemType>) => void;
  onCompleteSearch?: () => void;
  onSearchedTextUpdate?: (text: string, isSuggestedItem?: boolean) => void;
  onClearClick?: () => void;
  onMenuOpen?: () => void;
  onTrackEvent?: (event: string, props?: Obj) => void;
  placeholder?: string;
  resultDisplayMode?: ResultDisplayMode;
  searchedText?: string;
  sections?: Array<Section<ItemType>>;
  skipRecentlySearched?: boolean;
  theme?: InputTheme;
  includeHrefRecentTerms?: boolean;
};
type SearchInputJsxProps = {
  params: SearchInputParams;
};
export class SearchInput extends ParamComponent<SearchInputParams, SearchInputState, IronContextRegistry> {
  get config() {
    return {
      useShadowDom: true,
      css,
      contexts: ["urlManager" as const, "currentProject" as const, "i18n" as const],
      template: () => {
        var _this$params$actionTe, _this$getSections;
        return <div sel='.search-input-container'>
            <InputEl sel='.search-input' attrs={{
            'action-text': (_this$params$actionTe = this.params.actionText) !== null && _this$params$actionTe !== void 0 ? _this$params$actionTe : "",
            icon: "brand-search",
            placeholder: this.getSearchPlaceholder(),
            'show-clear': true,
            theme: this.params.theme,
            elref: "searchInput"
          }} props={{
            value: this.params.searchedText
          }} on={{
            input: ev => this.handleSearchInputChange(ev.target.value),
            clear: () => {
              var _this$params$onClearC, _this$params;
              this.handleSearchInputChange(DEFAULT_SEARCH_QUERY_STRING);
              (_this$params$onClearC = (_this$params = this.params).onClearClick) === null || _this$params$onClearC === void 0 || _this$params$onClearC.call(_this$params);
            },
            click: () => this.onFocusInput(),
            focus: () => this.onFocusInput()
          }} hook={{
            insert: vnode => this.handleSearchInputInserted(vnode.elm)
          }} />
            {Boolean((_this$getSections = this.getSections()) === null || _this$getSections === void 0 ? void 0 : _this$getSections.length) && (this.isListMode() ? this.renderItemsMenu() : this.state.isMenuOpen && <DropMenuEl attrs={{
            open: true,
            'prevent-close-selectors': ["mp-input.search-input"],
            'disable-auto-focus': true
          }} on={{
            change: (ev: VisibilityChangeEvent) => this.handleDropMenuVisibilityChange(ev)
          }} style={{
            width: "".concat(this.offsetWidth, "px")
          }}>
                      {this.renderItemsMenu()}
                    </DropMenuEl>)}
          </div>;
      },
      defaultState: {
        allowRecentItems: true,
        isMenuOpen: false
      },
      params: {
        actionText: String,
        onEnterPressed: Function,
        onItemClick: Function,
        onCompleteSearch: Function,
        onMenuOpen: Function,
        onSearchedTextUpdate: Function,
        onTrackEvent: Function,
        onClearClick: Function,
        placeholder: String,
        resultDisplayMode: String,
        searchedText: String,
        sections: Array,
        skipRecentlySearched: Boolean,
        theme: String,
        includeHrefRecentTerms: Boolean
      },
      defaultParams: {
        resultDisplayMode: ResultDisplayMode.DropMenu,
        searchedText: "",
        includeHrefRecentTerms: true
      }
    };
  }
  renderItemsMenu() {
    return <ItemsMenuEl attrs={{
      elref: "searchInputItemsMenu",
      'disable-auto-focus': true
    }} props={{
      sections: this.getSections(),
      keydownProxyEl: this.state.searchInputEl
    }} on={{
      clickItem: ev => this.handleSearchSelection(ev)
    }} />;
  }
  connectedCallback() {
    super.connectedCallback();

    /**
     * Binding the `keydown` listener to this component rather than the mp-input we render,
     * since the mp-input is used as a keydown proxy for mp-items-menu. If mp-items-menu is unable to deal with
     * the keydown event, it will bubble up to this component's handler.
     * Otherwise, we have two keydown listeners on mp-input and we won't be able to guarantee order of execution.
     */
    useEventListener(this, this, "keydown", (ev: KeyboardEvent) => this.handleSearchInputKeydown(ev));
    this.updateAllowStorage();
  }
  get t() {
    return this.getContext("i18n").t;
  }
  isListMode() {
    return this.params.resultDisplayMode === ResultDisplayMode.List;
  }
  handleSearchInputInserted(el) {
    this.update({
      searchInputEl: el
    });
  }
  handleDropMenuVisibilityChange(ev: VisibilityChangeEvent) {
    const isMenuOpen = ev.detail.state === Visibility.Open;
    this.update({
      isMenuOpen
    });
    if (isMenuOpen === false) {
      var _this$state$searchInp;
      (_this$state$searchInp = this.state.searchInputEl) === null || _this$state$searchInp === void 0 || _this$state$searchInp.blur();
    }
  }
  handleSearchInputChange(searchedText: string) {
    var _this$params$onSearch, _this$params2;
    let isSuggestedItem = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    (_this$params$onSearch = (_this$params2 = this.params).onSearchedTextUpdate) === null || _this$params$onSearch === void 0 || _this$params$onSearch.call(_this$params2, searchedText, isSuggestedItem);
  }
  handleSearchInputKeydown(ev: KeyboardEvent) {
    if (ev.code === KEY_VALUES.ENTER && this.params.onEnterPressed) {
      var _this$params$onComple, _this$params3;
      ev.preventDefault();
      ev.stopPropagation();
      this.params.onEnterPressed();
      (_this$params$onComple = (_this$params3 = this.params).onCompleteSearch) === null || _this$params$onComple === void 0 || _this$params$onComple.call(_this$params3);
      if (!this.isListMode()) {
        this.closeSearchMenu();
      }
    }
  }
  handleSearchSelection(ev) {
    var _this$params$onComple2, _this$params5;
    const item = ev.detail;
    if (item.type === RECENT_TERM_TYPE) {
      this.handleSearchInputChange(item.label, true);
      this.addRecentSearchItem(item.label);
    } else if (!item.isReadOnly) {
      var _this$params$onItemCl, _this$params4;
      (_this$params$onItemCl = (_this$params4 = this.params).onItemClick) === null || _this$params$onItemCl === void 0 || _this$params$onItemCl.call(_this$params4, item);
      if (this.params.searchedText !== DEFAULT_SEARCH_QUERY_STRING) {
        this.addRecentSearchItem(this.params.searchedText);
      }
    }
    (_this$params$onComple2 = (_this$params5 = this.params).onCompleteSearch) === null || _this$params$onComple2 === void 0 || _this$params$onComple2.call(_this$params5);
    if (!this.isListMode()) {
      this.closeSearchMenu();
    }
  }
  closeSearchMenu(): void {
    var _this$state$searchInp2;
    this.update({
      isMenuOpen: false
    });
    (_this$state$searchInp2 = this.state.searchInputEl) === null || _this$state$searchInp2 === void 0 || _this$state$searchInp2.blur();
  }
  onFocusInput(): void {
    var _this$state$searchInp3;
    if (!this.isListMode() && !this.state.isMenuOpen) {
      var _this$params$onMenuOp, _this$params6;
      this.update({
        isMenuOpen: true
      });
      (_this$params$onMenuOp = (_this$params6 = this.params).onMenuOpen) === null || _this$params$onMenuOp === void 0 || _this$params$onMenuOp.call(_this$params6);
    }
    (_this$state$searchInp3 = this.state.searchInputEl) === null || _this$state$searchInp3 === void 0 || _this$state$searchInp3.focus();
  }
  getSearchPlaceholder(): string {
    var _this$params$placehol;
    return (_this$params$placehol = this.params.placeholder) !== null && _this$params$placehol !== void 0 ? _this$params$placehol : this.t("search.placeholder");
  }
  getSections() {
    var _this$params$sections;
    const isDefault = this.params.searchedText === DEFAULT_SEARCH_QUERY_STRING;
    return [...(isDefault && !this.params.skipRecentlySearched ? this.getRecentTermsSection() : []), ...((_this$params$sections = this.params.sections) !== null && _this$params$sections !== void 0 ? _this$params$sections : [])];
  }
  private async updateAllowStorage() {
    var _window$gdprData, _window$gdprData2;
    await ((_window$gdprData = window.gdprData) === null || _window$gdprData === void 0 ? void 0 : _window$gdprData.waitUntilReady());
    this.update({
      allowRecentItems: (_window$gdprData2 = window.gdprData) === null || _window$gdprData2 === void 0 ? void 0 : _window$gdprData2.allowStorage
    });
  }
  private addRecentSearchItem(text: string) {
    searchUtils.addRecentItem({
      icon: "search",
      key: "".concat(RecentSearchItemType.SearchTerm, "-").concat(text),
      label: text,
      type: RecentSearchItemType.SearchTerm
    });
  }
  private getRecentTermsSection(): Section[] {
    var _searchUtils$getRecen;
    const {
      allowRecentItems
    } = this.state;
    const recentSearchTerms = (_searchUtils$getRecen = searchUtils.getRecentItems()) === null || _searchUtils$getRecen === void 0 ? void 0 : _searchUtils$getRecen.filter(item => item.type === RecentSearchItemType.SearchTerm);
    const items: SectionItem[] = (recentSearchTerms === null || recentSearchTerms === void 0 ? void 0 : recentSearchTerms.length) > 0 ? recentSearchTerms.slice(0, 3).map((item): SectionItem => {
      return _objectSpread({
        label: item.label,
        type: RECENT_TERM_TYPE,
        value: item
      }, this.params.includeHrefRecentTerms ? {
        href: getBrowseUrl({
          queryParam: {
            q: item.label
          }
        })
      } : {});
    }) : [{
      isReadOnly: true,
      label: allowRecentItems ? this.t("search.no-recent") : this.t(PROMPT_ALLOW_STORAGE_STRING),
      value: ""
    }];
    return [{
      label: this.t("search.recently-searched"),
      isLoading: false,
      hideTopDivider: true,
      actionsRenderer: item => {
        if (item.isReadOnly) {
          return null;
        }
        return <SvgIconEl attrs={{
          icon: "x",
          elref: "removeRecentItemIcon"
        }} on={{
          click: ev => {
            var _this$params$onTrackE, _this$params7;
            // prevent items menu select handler from firing
            ev.preventDefault();
            ev.stopPropagation();
            searchUtils.removeRecentItem(item.value);
            this.update();
            (_this$params$onTrackE = (_this$params7 = this.params).onTrackEvent) === null || _this$params$onTrackE === void 0 || _this$params$onTrackE.call(_this$params7, TypeaheadTrackedEvent.RecentResultDeleted);
          }
        }} />;
      },
      items
    }];
  }
}
export const SearchInputEl = defineAndMakeJsxFactory<SearchInputJsxProps>("mp-search-input", SearchInput);
export const SearchInputReact = panel2react<SearchInputJsxProps>("mp-search-input", SearchInput);